"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPrivacySignalEnum = exports.Purpose = exports.KnownDefaultPurpose = exports.ConfigurablePurpose = exports.DefaultConsentValue = exports.SpecialTrackingPurpose = void 0;
// main
const type_utils_1 = require("@transcend-io/type-utils");
/**
 * The options for the type of purpose that airgap classifies requests into
 */
exports.SpecialTrackingPurpose = (0, type_utils_1.makeEnum)({
    /** The request has an unknown tracking purpose */
    Unknown: 'Unknown',
    /** The request is necessary for the essential features of the website */
    Essential: 'Essential',
});
/**
 * Possible values for the default consent that can be given to a tracking purpose
 */
exports.DefaultConsentValue = (0, type_utils_1.makeEnum)({
    /** Tracking purpose is NOT consented to by default */
    Off: 'off',
    /**
     * Tracking purpose is consented to by default, unless user is protected by GDPR
     * or has DNT or GPC enabled
     */
    Auto: 'Auto',
});
/**
 * Purposes that can be configured
 */
exports.ConfigurablePurpose = (0, type_utils_1.makeEnum)({
    /** SaaS tools used for advertising purposes */
    Advertising: 'Advertising',
    /** SaaS tools used for analytics purposes */
    Analytics: 'Analytics',
    /** SaaS tools used for functional purposes */
    Functional: 'Functional',
    /** SaaS tools used for selling personal information */
    SaleOfInfo: 'SaleOfInfo',
});
/**
 * Purposes that can be configured
 */
exports.KnownDefaultPurpose = (0, type_utils_1.makeEnum)({
    /** The request is necessary for the essential features of the website */
    Essential: 'Essential',
    ...exports.ConfigurablePurpose,
});
/**
 * Purposes used by the purpose map
 */
exports.Purpose = (0, type_utils_1.makeEnum)({
    ...exports.SpecialTrackingPurpose,
    ...exports.ConfigurablePurpose,
});
/** User-configurable user agent privacy signal */
exports.UserPrivacySignalEnum = (0, type_utils_1.makeEnum)({
    /** Global Privacy Control */
    GPC: 'GPC',
    /** Do Not Track */
    DNT: 'DNT',
});
//# sourceMappingURL=purpose.js.map